<!-- WaterQualityList.vue -->
<template>
  <van-cell-group>
    <van-cell :title="title + '信息'" title-style="font-weight: bold;font-size: 16px;">
      <template>
        <span style="color: blue;" @click="handleViewAll(title)">查看全部</span>
      </template>
    </van-cell>
    <van-loading v-if="loading" size="24px" class="loading">加载中...</van-loading>
    <van-empty v-else-if="list.length === 0" :description="`暂无${title}数据`" />
    <van-row v-else>
      <van-col v-for="(item, index) in list" :key="index" span="12">
        <van-cell :title="item.name" :label="item.levelText" title-style="white-space: nowrap" @click="goToRiverDetail(item.id)">
          <template>
            <img :src="require('@/assets/icon/quality/' + item.waterLevel + '.png')" width="30px"
                  style="display: inline-block; vertical-align: middle">
          </template>
        </van-cell>
      </van-col>
    </van-row>
  </van-cell-group>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
    loading: Boolean,
  },
  methods: {
    waterLevelClass(item) {
      return item.waterLevelText.substring(0, item.waterLevelText.length - 1);
    },
    handleViewAll(title) {
      localStorage.setItem("riverTypeTitle", title)
      this.$router.push({ name: 'WaterQualityAll' });
    },
    goToRiverDetail(id) {
      const title = this.title
      localStorage.setItem("riverTypeTitle",title)
      this.$router.push({ name: 'RiverDetail', params: { id } });
    },
  },
};
</script>
<style scoped>
.value-diamond {
  position: relative;
  display: inline-block;
  padding: 8px 16px;
  /* 设置文字为白色 */
  color: white; 
  text-align: center;
  /* 确保文字在伪元素之上 */
  /* z-index: 1;  */
  overflow: visible; /* 避免内容被裁剪 */
}

.value-diamond::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 140%; /* 扩大尺寸以覆盖旋转后的区域 */
  height: 140%;
  background-color: var(--bg-color);
  transform: translate(-50%, -50%) rotate(45deg); /* 居中并旋转 */
  z-index: -1; /* 置于文字下方 */
  border-radius: 4px;
}

/* 颜色变量定义 */
:root {
  --color-I: #14c7f8;
  --color-II: #15aaf1;
  --color-III: #5ed522;
  --color-IV: #24b462;
  --color-V: #ffc20d;
}
.color-I {
  background-color: #14c7f8;
}
.color-II {
  background-color: #15aaf1;
}
.color-III {
  background-color: #5ed522;
}
.color-IV {
  background-color: #24b462;
}
.color-V {
  background-color: #ffc20d;
}
</style>
